export const THEME_HAVET = 'havet-theme'
export const THEME_LIVET = 'livet-theme'
export const THEME_HU = 'havsutsikt-theme'

export default [
  { id: 'HavetStandard', title: 'Havet standardsida', theme: THEME_HAVET },
  { id: 'LivetStandard', title: 'Livet standardsida', theme: THEME_LIVET },
  {
    id: 'HavsutsiktStandard',
    title: 'Havsutsikt standardsida',
    theme: THEME_HU,
  },
]
